import React from "react";
import { Link } from "@/components/common/Link";
import { Facebook, Instagram, Linkedin, Music2 } from "lucide-react";
export default function HeroProducts() {
  const socialLinks = [{
    name: "LinkedIn",
    icon: Linkedin,
    url: "https://wa.me/526149800517",
    bgClass: "bg-primary-600 hover:bg-primary-500"
  }, {
    name: "Facebook",
    icon: Facebook,
    url: "https://wa.me/526149800517",
    bgClass: "bg-primary-800 hover:bg-primary-700"
  }, {
    name: "Instagram",
    icon: Instagram,
    url: "https://wa.me/526149800517",
    bgClass: "bg-secondary hover:bg-secondary-400"
  }];
  return <section id="heroproducts" className="relative w-full h-[50vh] min-h-[400px] md:h-[60vh] lg:h-[70vh] bg-background flex items-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/hero_productos_bg.png" alt="Fondo de productos de acero" className="w-full h-full object-cover" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/hero_productos_bg.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/hero_productos_bg.png-wvc-sizes" loading="lazy" />
        {}
        <div className="absolute inset-0 bg-primary/60 mix-blend-multiply"></div>
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>
      </div>

      {}
      <div className="relative z-10 container mx-auto px-6 md:px-12 lg:px-24 flex flex-col justify-center h-full">
        <div className="max-w-5xl">
          <p className="text-white/90 text-xs md:text-sm font-semibold tracking-[0.25em] uppercase mb-2 md:mb-4">
            Reducimos tu tiempo con cortes a tu medida
          </p>
          <h1 className="text-7xl md:text-8xl lg:text-[10rem] xl:text-[12rem] font-bold text-white leading-none font-default uppercase tracking-tighter">
            Productos
          </h1>
        </div>
      </div>

      {}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 z-20 flex flex-col shadow-xl">
        {socialLinks.map((social, i) => <div data-index={i} key={i}>
            <Link to={social.url} newTab className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 text-white transition-colors duration-300 ${social.bgClass}`} aria-label={`Visitar nuestro perfil de ${social.name}`}>
              <social.icon className="w-4 h-4 md:w-5 md:h-5" />
            </Link>
          </div>)}
      </div>
    </section>;
}